import type { IReturnAddressSource } from '@talbenmoshe/trip-os-react-model';

/** The part of the browser's `Location` this adapter needs, so tests can pass a stand-in. */
export interface ISearchableLocation {
  readonly search: string;
}

/**
 * Reads `returnTo` from the login page's own address — where the gate sent the visitor from. It is passed on
 * unvalidated: the identity service alone decides whether it is a safe destination.
 */
export class LocationReturnAddressSource implements IReturnAddressSource {
  constructor(private readonly location: ISearchableLocation) {}

  getReturnAddress(): string | undefined {
    return new URLSearchParams(this.location.search).get('returnTo') ?? undefined;
  }
}
